module.exports = __webpack_public_path__ + "static/media/google.cd41931b.png";